'use strict';
require('./VendorPurchaseAdmin.scss');

const React = require('react'),
    { t } = require('services/i18nextWrapper'),
    DateUtils = require('utils/DateUtils'),
    { map, find } = require('lodash/collection'),
    SessionStore = require('stores/SessionStore'),
    FlatSphere = require('components/Commons/FlatSphere/FlatSphere'),
    Notification = require('components/Notification/Notification'),
    AdminScaffolding = require('components/Commons/AdminScaffolding/AdminScaffolding'),
    AdminScaffoldingTablePaged = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTablePaged'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Loading = require('components/Commons/Loading/Loading'),
    ContentUtils = require('utils/ContentUtils'),
    NavigationUtils = require('utils/NavigationUtils'),
    { Navigation } = require('react-router'),
    NumberUtils = require('utils/NumberUtils'),
    PurchaseOrderUtils = require('utils/PurchaseOrderUtils'),
    AppConstants = require('constants/AppConstants'),
    InventoryStore = require('stores/InventoryStore'),
    FormGroupTextfield = require('components/Commons/BasicForm/FormGroupTextfield/FormGroupTextfield'),
    FormGroupTextFieldSuggested = require('components/Commons/BasicForm/FormGroupTextFieldSuggested/FormGroupTextFieldSuggested'),
    Authentication = require('services/Security').Authentication,
    ga = require('react-ga'),
    get = require('lodash/object').get,
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder');

const pageUrl = '/purchase-item/page/';

const VendorPurchaseAdmin = React.createClass({displayName: "VendorPurchaseAdmin",

    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        
        return {
            selectedItem: null,
            isEditMode: false,
            isFetching: true,
            filter: {
                code: '',
                companyName: '',
                displayDateOpen: '',
                displayEstimatedDateArrive: '',
                state: '',
                amountPaid:'',
                estimatedPricesWithCurrency:'',
                daysLeft:''
            }
        };
    },

    componentDidMount() {
        this.fetchPurchases();
        ga.pageview('/vendor-purchase-admin');
    },

    fetchPurchases() {
        const self = this;
        const currentPage = NavigationUtils.getPathParam('page');
        InventoryStore.fetchLocation(function (locations) {
            InventoryStore.fetchVendor(function (vendors) {
                InventoryStore.fetchVendorPurchasesWithTotalPrice(currentPage, purchases => {
                    self.setState({
                        purchases: ContentUtils.filterEnable(self._sortPurchaseOrder(
                            self._hydrateAdditionalInfo(purchases, locations)
                        )),
                        vendors: ContentUtils.filterEnable(vendors),
                        locations: ContentUtils.filterEnable(locations),
                        isFetching: false
                    });
                });
            });
        });
    },

    _onClickPage(page) {
        this.transitionTo('/purchase-item/page/:page', { page });
        this.fetchPurchases();
    },

    fetchPurchasesBy(filter) {
        const self = this;
        InventoryStore.fetchVendor(function (vendors) {
            InventoryStore.fetchVendorPurchasesBy(filter, purchases => {
                self.setState({
                    purchases: ContentUtils.filterEnable(self._sortPurchaseOrder(
                        self._hydrateAdditionalInfo(purchases)
                    )),
                    vendors: ContentUtils.filterEnable(vendors),
                    isFetching: false
                });
            });
        });
    },

    _hydrateAdditionalInfo(purchases, locations) {
        return map(purchases, purchase => {
            // estimate date arrive
            // format date properly
            purchase.displayDateOpen = DateUtils.toCurrentTimeZone(
                purchase.openDate,
                SessionStore.getCurrentTimeZone()
            );
            if (purchase.latestArrivalDate) {
                purchase.displayEstimatedDateArrive = DateUtils.toDateText(purchase.latestArrivalDate);
                purchase.daysLeft = PurchaseOrderUtils.getDaysLeftToBeReceivedFromPurchaseOrder(purchase, t);
            }
            // add currency to estimate purchase price
            purchase.estimatedPricesWithCurrency = `${get(
                SessionStore.getCurrentCurrency(),
                'symbol'
            )} ${NumberUtils.formatDecimal(purchase.totalPurchasePrice,get(SessionStore.getCurrentCurrencyDigits(), 'value')) || NumberUtils.formatDecimal(0,get(SessionStore.getCurrentCurrencyDigits(), 'value'))}`;
            purchase.shipTo = find(locations, location => location.id === purchase.shipToId);
            purchase.amountPaid = purchase.amountPaid ? `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(purchase.amountPaid,get(SessionStore.getCurrentCurrencyDigits(), 'value'))}` : `${NumberUtils.getCurrentCurrency().symbol} ${NumberUtils.formatDecimal(purchase.totalPurchasePrice,get(SessionStore.getCurrentCurrencyDigits(), 'value'))}`;
            return purchase;
        });
    },

    _sortPurchaseOrder(purchases) {
        return DateUtils.sortListByDateFieldDesc(purchases, 'dateCreated');
    },

    _getEarlyDate(purchaseItems) {
        const sortedPurchaseItems = DateUtils.sortListByDateField(
            purchaseItems,
            'dateRequested'
        );
        return get(sortedPurchaseItems, '0.openDate');
    },

    _onDeletePurchase(purchase, onSuccess, onFailure) {
        const selectedItem = this.state.selectedItem;

        if (isRemovable(selectedItem)) {
            CustomDialog.showWarningConfirmation(
                t('warning'),
                t('vendor_purchase_confirm_delete_purchase_order'),
                () => {
                    InventoryStore.deletePurchase(purchase, onSuccess, onFailure);
                }
            );
        } else {
            CustomDialog.showInfo(
                t('warning'),
                t('vendor_purchase_can_not_be_deleted')
            );
        }
    },

    _onChangePurchase(purchase, onSuccess) {
        InventoryStore.changeVendorPurchase(
            purchase,
            onSuccess,
            this._onFailure
        );
    },

    _onAddPurchase(purchase, onSuccess, onFailure) {
        InventoryStore.addVendorPurchase(purchase, onSuccess, onFailure);
    },

    _onRowSelection(purchase,
        itemIndex,
        lastRowScrollPosition,
        headerActiveFilters) {
        this.setState(
            {
                selectedItem: purchase,
                isEditMode: !!purchase,
                headerActiveFilters
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset Y es outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _isClosed() {
        return get(this.state, 'selectedItem.state') === 'CLOSED_COMPLETE' ||
            get(this.state, 'selectedItem.state') === 'CLOSED_COMPLETE_PAID' ||
            get(this.state, 'selectedItem.state') === 'CLOSED_RESOLVED' ||
            get(this.state, 'selectedItem.state') === 'CLOSED_RESOLVED_PAID' ||
            get(this.state, 'selectedItem.state').indexOf('RECEIVED') > -1;
    },

    _isPaid() {
        return get(this.state, 'selectedItem.state') === 'CLOSED_COMPLETE_PAID' ||
            get(this.state, 'selectedItem.state') === 'CLOSED_RESOLVED_PAID'
    },

    _goToSetItems() {
        this.transitionTo(
            'purchase-item/:purchaseId/vendors/:vendorId',
            {
                purchaseId: get(this.state, 'selectedItem.id'),
                vendorId: get(this.state, 'selectedItem.vendorId')
            },
            {
                companyName: get(this.state, 'selectedItem.companyName'),
                code: get(this.state, 'selectedItem.code'),
                isClosed: this._isClosed(),
                comment: get(this.state, 'selectedItem.comment')
            }
        );
    },

    _goToReceive() {
        this.transitionTo(
            'purchase-item/:purchaseId/vendors/:vendorId/receive',
            {
                purchaseId: get(this.state.selectedItem, 'id'),
                vendorId: get(this.state, 'selectedItem.vendorId')
            },
            {
                companyName: get(this.state, 'selectedItem.companyName'),
                code: get(this.state, 'selectedItem.code'),
                isClosed: this._isClosed()
            }
        );
    },

    _onCancel() {
        this.setState({
            selectedItem: null,
            isEditMode: false,
            filter: {
                code: '',
                state: '',
                companyName: '',
                displayDateOpen: '',
                displayEstimatedDateArrive: '',
                estimatedPricesWithCurrency:'',
                amountPaid:'',
                daysLeft:''
            }
        });
        this._onClickPage(0);
    },

    _onFailure(messageInfo) {
        if (messageInfo) {
            const messageError = ContentUtils.formatMessageError(messageInfo);
            Notification.show(messageError);
        }
    },

    _onEnterPress() {
        if (this.onEnterKeyDown) {
            this.onEnterKeyDown();
        }
    },

    _addEnterKeyDown(onEnterKeyDown) {
        this.onEnterKeyDown = onEnterKeyDown;
    },

    _getBreadcrumbLinks() {
        return [{ displayName: t('vendor_purchase_purchase_order') }];
    },

    _sendToProvider() {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('vendor_purchase_confirm_supplier_notification'),
            () => {
                InventoryStore.sendVendorPurchaseOrder(
                    get(this.state.selectedItem, 'id'),
                    this._onSuccessPurchaseItem,
                    this._onFailurePurchaseItem
                );
            }
        );
    },

    _onSuccessPurchaseItem() {
        this.fetchPurchases(() => {
            Notification.show(
                t('vendor_purchase_confirm_order_was_sent'),
                'success'
            );
        });
    },

    _onFailurePurchaseItem(messageInfo) {
        if (messageInfo) {
            const haveNotEmail = messageInfo.includes('0008');
            if (haveNotEmail) {
                CustomDialog.showWarningConfirmation(
                    t('warning'),
                    t('vendor_purchase_no_email_associated_with_vendor'),
                    () => {
                        this.transitionTo(
                            '/vendors/:vendorId/contacts',
                            {
                                vendorId: NavigationUtils.getPathParam('vendors')
                            },
                            {
                                companyName: NavigationUtils.getQueryParam('companyName')
                            }
                        );
                    }
                );

            } else {
                const messageError = ContentUtils.formatMessageError(messageInfo);
                Notification.show(messageError);
            }
        }
    },

    _showIndicator(purchase, field) {
        let colorFlat = 'red';

        const statusKey = get(purchase, field || 'displayState');
        const displayState = AppConstants.getPurchaseStateMapping(t)[statusKey]
        const statePurchase = get(purchase, 'state');
        const isRedState = AppConstants.PURCHASE_RED_STATE.includes(statePurchase);
        const isYellowState = AppConstants.PURCHASE_YELLOW_STATE.includes(statePurchase);
        const isGreenState = AppConstants.PURCHASE_GREEN_STATE.includes(statePurchase);

        if (isRedState) {
            colorFlat = 'red';
        } else if (isYellowState) {
            colorFlat = 'yellow';
        } else if (isGreenState) {
            colorFlat = 'green';
        }
        return (
            React.createElement(FlatSphere, {bgColor: colorFlat, text: displayState})
        );
    },

    _onDuplicate(contextHolder) {
        // get value from all fields
        let currentSelectedItem = contextHolder.getItem();

        // set purchase id
        currentSelectedItem.purchase = { id: this.state.selectedItem.id };

        InventoryStore.duplicateVendorPurchase(currentSelectedItem, () => {
            Notification.show(t('vendor_purchase_duplicated_purchase'), 'success');
            this.fetchPurchases();
        });
    },

    _onPaid() {
        InventoryStore.markPaidVendorPurchase(this.state.selectedItem.id, () => {
            this._isPaid() ? Notification.show(t('vendor_purchase_removed_paid') + " " + this.state.selectedItem.code, 'success') : Notification.show(t('order').charAt(0).toUpperCase() + t('order').slice(1) + " " + this.state.selectedItem.code + t('vendor_purchase_marked_paid'), 'success');
            this.fetchPurchases();
            this.state.selectedItem = null;
        });
    },

    _onChangeAmount(purchase){
        this.state.amountPaid = purchase.target.value;
      },

    _amountValidation(inputValue) {
        if (ContentUtils.isEmptyText(inputValue)) {
            return '';
        }
        if (get(inputValue, 'length') > 17) {
            return t('vendor_purchase_max_price');
        }

        switch(NumberUtils.getCurrentCurrency().decimalSeparator){
            case '.':
                if (!/^(?:\d{1,3}(?:\,\d{3})*(?:.\d+)?|\d+(\.\d*)?)$/.test(inputValue)) {
                    return t('notification_error_invalid_character');
                };
                break;
            case ',':
                if (!/^(?:\d{1,3}(?:\.\d{3})*(?:,\d+)?|\d+(\,\d*)?)$/.test(inputValue)) {
                    return t('notification_error_invalid_character');
                };
                break;
          }
        /*if (+inputValue.split(",")[0] > +get(this.state.selectedItem, 'totalSalePrice') !== null ? +get(this.state.selectedItem, 'totalSalePrice').split(",")[0] : 0) {
          return t('notification_error_invalid_character');
        } */
    
        return '';
      },

    saveNewAmount() {
        let value = get(this.state, 'amountPaid');

        if(ContentUtils.isEmptyText(value)){
          value = get(this.state.selectedItem, 'totalPurchasePrice') ? get(this.state.selectedItem, 'totalPurchasePrice').replaceAll(".",",") : "0,00";
        }


        switch(NumberUtils.getCurrentCurrency().decimalSeparator){
            case '.':
                if (/^(?:\d{1,3}(?:\,\d{3})*(?:.\d+)?|\d+(\.\d*)?)$/.test(value)) {
                    InventoryStore.changeAmountPaidPO(
                        {
                          id: get(this.state.selectedItem, 'id'),
                          amountPaid: value
                        },
                        this.onSuccess,
                        this.__onFailureShowMessageError
                    );
                };
                break;
            case ',':
                if (/^(?:\d{1,3}(?:\.\d{3})*(?:,\d+)?|\d+(\,\d*)?)$/.test(value)) {
                    InventoryStore.changeAmountPaidPO(
                        {
                          id: get(this.state.selectedItem, 'id'),
                          amountPaid: value
                        },
                        this.onSuccess,
                        this.__onFailureShowMessageError
                    );
                };
                break;
          }
        this.fetchPurchases();
        this._onCancel();
      },

    _onTypingFilter(name, match) {
        if (!this.state.isFetching) {
            this.setState(prevState => {
                let nextFilter = prevState.filter || {};
                nextFilter[name] = match;
                this.fetchPurchasesBy(nextFilter);
                return {
                    filter: nextFilter,
                    isFetching: true
                };
            });
        }
    },

    _commentValidation(comment) {
        if (ContentUtils.isEmptyText(comment)) {
            return '';
        }

        if (get(comment, 'length') >= 500) {
            return t('vendor_purchase_max_amount_characters');
        }

        return '';
    },

    _printReport() {
        InventoryStore.downloadReportXLS(this.state.filter, 'vendors/purchases');
    },

    render() {
        if (!this.state.purchases) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('vendor_purchase_change_success_message'),
                changeFailureMessage: t('vendor_purchase_change_failure_message'),
                deleteSuccessMessage: t('vendor_purchase_delete_success_message'),
                addSuccessMessage: t('vendor_purchase_add_success_message'),
                addFailureMessage: t('vendor_purchase_add_failure_message')
            };
            const displayStateMapping = AppConstants.getPurchaseStateMapping(t);
            const contextHolder = this.getContextHolderInstance();
            const { selectedItem, purchases, isEditMode, vendors, isFetching, locations } = this.state;
            const stateSelected = get(selectedItem, 'state') || '';
            const isClosed = stateSelected.includes('CLOSED');
            const isReceived = stateSelected.includes('RECEIVED');
            const purchaseWithDisplayText = (purchases || []).map(purchase => {
                purchase.displayState = displayStateMapping[purchase.state];
                if (purchase.latestArrivalDate) {
                    purchase.daysLeft = PurchaseOrderUtils.getDaysLeftToBeReceivedFromPurchaseOrder(purchase, t);
                }
                return purchase;
            });

            const state = {'state':[]};
            if(displayStateMapping['OPEN'] !== undefined){
            Object.keys(displayStateMapping).forEach((e)=>{
                state['state'].push({id: e, state: displayStateMapping[e]});
            })};

            const formFieldsEl = [
                React.createElement(FormGroupTextFieldSuggested, {
                    operationsHolder: contextHolder, 
                    items: vendors, 
                    readerAttribute: "companyName", 
                    readerAttributeValue: "id", 
                    writerAttribute: "vendor.id", 
                    customErrorNonMatch: t('notification_supplier_name_required'), 
                    label: t('vendor_purchase_label_supplier_name'), 
                    name: t('vendor_purchase_label_supplier_name'), 
                    value: get(selectedItem, 'vendor') || find(vendors, vendor => get(vendor, 'id') === get(selectedItem, 'vendorId')), 
                    isImmutable: true, 
                    isEditMode: isEditMode, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupDropdown, {
                    items: locations, 
                    operationsHolder: contextHolder, 
                    readerAttribute: "name", 
                    writerAttribute: "shipTo", 
                    customReaderWriterAttribute: "id", 
                    name: t('vendor_purchase_label_ship_to'), 
                    label: t('vendor_purchase_label_ship_to'), 
                    value: get(selectedItem, 'shipTo'), 
                    isEditMode: isEditMode, 
                    isRequired: true, 
                    onEnter: this._onEnterPress}
                ),
                React.createElement(FormGroupTextfield, {
                    isRelaxedText: false, 
                    additionalValidation: inputValue => this._amountValidation(inputValue), 
                    noInternalValidation: true, 
                    operationsHolder: contextHolder, 
                    writerAttribute: "amountPaid", 
                    name: t('sales_column_amount_paid'), 
                    value: (get(selectedItem, "amountPaid", '').replace("$ ","")).toString(), 
                    label: t('sales_column_amount_paid'), 
                    formatDecimal: get(SessionStore.getCurrentCurrencyDigits(), 'value'), 
                    isEditMode: isEditMode, 
                    isRequired: false, 
                    onChange: this._onChangeAmount}
                ),
                React.createElement(FormGroupTextfield, {
                    operationsHolder: contextHolder, 
                    readerAttribute: "comment", 
                    name: t('comment'), 
                    value: selectedItem, 
                    label: t('comment'), 
                    additionalValidation: this._commentValidation, 
                    isRelaxedText: false, 
                    noInternalValidation: true, 
                    isEditMode: isEditMode, 
                    isRequired: false, 
                    onEnter: this._onEnterPress, 
                    id: "comment"}
                )
            ];

            let additionalButtons = [{
                type: 'CHANGE',
                permission: 'VIEW_ORDER',
                el: (
                    React.createElement(FormGroupButton, {
                        label: isClosed || isReceived ? t('vendor_purchase_label_view_order') : t('vendor_purchase_label_edit_order'), 
                        icon: isClosed || isReceived ? 'visibility' : 'mode_edit', 
                        type: "icon", 
                        onClick: this._goToSetItems}
                    )
                )
            },
            {
                type: 'NEW',
                permission: 'PRINT_REPORT',
                el: (
                    React.createElement(FormGroupButton, {
                        label: t('vendor_purchase_label_print_report'), 
                        icon: "file_download", 
                        type: "icon", 
                        onClick: this._printReport}
                    )
                )
            },
                {
                    type: 'NEW',
                    permission: 'CLEAR_FILTER',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('button_label_clear_filters'), 
                            icon: "clear", 
                            type: "icon", 
                            onClick: this._onCancel.bind()}
                        )
                    )
                }];

            if (selectedItem) {
                const haveSomePurchaseItem = NumberUtils.isGreater(get(selectedItem, 'itemsAmount'), 0);
                const haveSomePurchaseItemPending = selectedItem.state === 'OPEN_PENDING';
                const isAlreadyNotified = selectedItem.state === 'OPEN_ORDERED' || selectedItem.state === 'ORDER_PARTIALLY_RECEIVED';

                if (isAlreadyNotified) {
                    additionalButtons.push(
                        {
                            type: 'CHANGE',
                            permission: 'VIEW_ORDER',
                            el: (
                                React.createElement(FormGroupButton, {
                                    label: isClosed ? t('vendor_purchase_label_view_order') : t('vendor_purchase_label_receive_order'), 
                                    icon: isClosed ? 'visibility' : 'local_shipping', 
                                    type: "icon", 
                                    onClick: this._goToReceive}
                                )
                            )
                        });
                }

                if (!isClosed) {
                    if (haveSomePurchaseItem && haveSomePurchaseItemPending) {
                        additionalButtons.push({
                            permission: 'SEND_PENDING_ORDER',
                            type: 'CHANGE',
                            el: (
                                React.createElement(FormGroupButton, {
                                    label: t('vendor_purchase_label_send_pending'), 
                                    icon: "send", 
                                    type: "icon", 
                                    onClick: this._sendToProvider}
                                )
                            )
                        });
                    }
                }

                additionalButtons.push(
                    {
                        type: 'CHANGE',
                        permission: 'DUPLICATE',
                        el: (
                            React.createElement(FormGroupButton, {
                                label: t('button_duplicate'), 
                                icon: "content_copy", 
                                type: "icon", 
                                onClick: this._onDuplicate.bind(this, contextHolder)}
                            )
                        )
                    });

                additionalButtons.push(
                    {
                        type: 'CHANGE',
                        permission: 'MARK_PAID',
                        el: (this._isClosed() &&
                            React.createElement(FormGroupButton, {
                                label: this._isPaid() ? t('button_revert_paid') : t('button_mark_paid'), 
                                icon: "paid", 
                                type: "icon", 
                                onClick: this._onPaid.bind()}
                            )
                        )
                    });

                    additionalButtons.push(
                        {
                        type: 'CHANGE',
                        permission: 'EDIT_ORDER',
                        el: (
                        React.createElement(FormGroupButton, {
                            label: t('vendor_change_amount'), 
                            icon: 
                              'mode_edit', 
                            
                            type: "icon", 
                            onClick: this.saveNewAmount}
                          )
                        )
                      });
            }

            const totalPurchases = get(purchases, '0.count') || 0;

            

            return (
                React.createElement(AdminScaffolding, {
                    messages: messages, 
                    moduleName: "ADMIN_PURCHASE", 
                    additionalButtons: additionalButtons, 
                    title: 
                        isEditMode
                            ? t('vendor_purchase_title_button_edit_order')
                            : t('vendor_purchase_title_button_new_order'), 
                    
                    contextHolder: contextHolder, 
                    value: selectedItem, 
                    onAddText: t('vendor_purchase_text_create'), 
                    fetchItems: this.fetchPurchases, 
                    headerFields: formFieldsEl, 
                    onAdd: this._onAddPurchase, 
                    onChange: this._onChangePurchase, 
                    onCancel: this._onCancel, 
                    onDelete: this._onDeletePurchase, 
                    addEnterKeyDown: this._addEnterKeyDown, 
                    breadcrumb: this._getBreadcrumbLinks()
                }, 
                  React.createElement("div", {className: "admin-table-vendor-purchase-width"}, 
                    React.createElement(AdminScaffoldingTablePaged, {
                        onRowSelection: this._onRowSelection, 
                        value: selectedItem, 
                        filteredColumns: [
                            'code',
                            'companyName',
                            'state',
                            'displayDateOpen',
                            'displayEstimatedDateArrive',
                            'amountPaid',
                            'estimatedPricesWithCurrency',
                            'daysLeft'
                        ], 
                        displayAttributes: [
                            'code',
                            'companyName',
                            {
                                name: 'state',
                                getHTML: this._showIndicator
                            },
                            'displayDateOpen',
                            'displayEstimatedDateArrive',
                            'amountPaid',
                            'estimatedPricesWithCurrency',
                            'daysLeft'
                        ], 
                        columnNames: [
                            t('vendor_purchase_column_name_number'),
                            t('vendor_purchase_column_name_supplier'),
                            t('vendor_purchase_column_name_status'),
                            t('vendor_purchase_column_name_created'),
                            t('vendor_purchase_column_name_arrive'),
                            t('vendor_purchase_column_amount_paid'),
                            t('vendor_purchase_column_name_price'),
                            t('vendor_purchase_column_name_days_left')
                        ], 
                        isLoading: isFetching, 
                        maxPage: ContentUtils.getAmountPageNeeded(totalPurchases, AppConstants.MAX_ITEMS_BY_PAGES_ADMINS), 
                        onClickPage: this._onClickPage, 
                        currentPage: NavigationUtils.getPathParam('page'), 
                        columnsFilterValue: this.state.filter, 
                        onCancel: this._onCancel, 
                        onTypingFilter: this._onTypingFilter, 
                        items: state
                    }, 
                        ContentUtils.filterEnable(purchaseWithDisplayText)
                    )
                  )
                )
            );
        }
    }
});
function getCurrentUrl() {
    return pageUrl + NavigationUtils.getPathParam('page');
}
function isRemovable(selectedPurchase) {
    const statePurchase = get(selectedPurchase, 'state');
    return AppConstants.PURCHASE_STATES_REMOVABLE.includes(statePurchase);
}

module.exports = VendorPurchaseAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/VendorPurchaseAdmin/VendorPurchaseAdmin.jsx
 **/